import React, { Component } from "react";
import { connect } from "react-redux";
import axios, { CancelToken } from "axios";
import Form from "react-bootstrap/Form";

import { Translate, I18n } from "react-redux-i18n";

import { setAlert } from "../../../actions/alertActions";
import Modal from "react-bootstrap/Modal";

import "../../../styles/components/chargers/modals/ChargeAs.scss";

class ChargeAs extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;

    this.state = {
      tabIndex: 0,
      contractsList: [],
      evsList: [],
      selectedItem: null,
    };

    this.handleOnClick = this.handleOnClick.bind(this);
    this.fetchEvs = this.fetchEvs.bind(this);
    this.fetchContracts = this.fetchContracts.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    this.fetchEvs();
    this.fetchContracts();
  }

  componentWillUnmount() {
    this._mounted = false;
    if (this.cancel) this.cancel("Component is unmounting");
  }

  fetchEvs() {
    axios
      .get("api/private/evs", {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.safeSetState({
            evsList: res.data,
          });
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  fetchContracts() {
    axios
      .get("/api/private/contracts", {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.safeSetState({
            contractsList: res.data,
          });
        }
      })
      .catch((err) =>
        this.props.setAlert(err?.response?.data?.message, "danger")
      );
  }

  handleOnClick(e, idx) {
    this.safeSetState({
      tabIndex: !Number.isNaN(idx) ? idx : 1,
    });
  }

  onSave(e) {
    e.preventDefault();
    let selectedId, cardId;

    for (let item = 0; item < e.target.elements.length; item++) {
      if (e.target.elements[item].checked === true) {
        selectedId = e.target.elements[item].value;
      }
    }

    if (this.state.tabIndex === 0) {
      const selectedItemEv = this.state.evsList.filter(
        (item) => item._id === selectedId
      );

      if (!selectedItemEv[0].hasFleet) {
        cardId = this.state.contractsList.filter(
          (item) => item._id === selectedItemEv[0].contractId
        );
      } else {
        cardId = this.state.contractsList.filter(
          (item) => item.contractType === "user"
        );
      }

      this.props.onSubmit.evs_chargeAs(selectedItemEv[0], cardId[0]);
    } else {
      const selectedItemCard = this.state.contractsList.filter(
        (item) => item._id === selectedId
      );

      this.props.onSubmit.cards_chargeAs(selectedItemCard[0]);
    }
  }

  renderItemsEv(item) {
    return (
      <div className="row mb-3 d-flex align-items-center">
        <div className="col-1">
          <Form.Check type="radio" className="check-container">
            <Form.Check.Input type="radio" name="evRadio" value={item._id} />
            <div className="check" />
          </Form.Check>
        </div>
        <div className="col-3 d-flex justify-content-center">
          <img src={item.imageContent} width="100%" alt="" />
        </div>
        <div className="col-4 d-flex justify-content-center">
          <span>{item.brand}</span>
        </div>
        <div className="col-4 d-flex justify-content-center">
          <span>{item.licensePlate}</span>
        </div>
      </div>
    );
  }

  renderItemsCard(item) {
    return (
      <>
        <div className="row mb-3 d-flex align-items-center">
          <div
            className={
              item.fleetId === undefined ? "col-1 disabled-btn" : "col-1"
            }
          >
            <Form.Check type="radio" className="check-container">
              <Form.Check.Input
                type="radio"
                name="cardRadio"
                value={item._id}
                disabled={item.fleetId === undefined}
              />
              <div className="check" />
            </Form.Check>
          </div>
          <div
            className={
              item.fleetId === undefined
                ? "col-3 disabled-btn d-flex justify-content-center"
                : "col-3 d-flex justify-content-center"
            }
          >
            <img src={item.imageCard} width="100%" alt="" />
          </div>
          <div
            className={
              item.fleetId === undefined
                ? "col-4 disabled-btn d-flex justify-content-center"
                : "col-4 d-flex justify-content-center"
            }
          >
            <span>{item.cardName}</span>
          </div>
          <div
            className={
              item.fleetId === undefined
                ? "col-4 disabled-btn d-flex justify-content-center"
                : "col-4 d-flex justify-content-center"
            }
          >
            <span>
              <Translate
                value={
                  item.hasOwnProperty("fleetId")
                    ? "contracts_network_fleet"
                    : "contracts_network_company"
                }
              />
            </span>
          </div>
        </div>
      </>
    );
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <>
        <Modal
          id="chargeAs"
          show={this.props.show}
          onHide={this.props.onHide}
          centered
        >
          <Modal.Header>
            <div className="tabs">
              <p
                className={this.state.tabIndex === 0 ? "selected" : ""}
                onClick={(e) => this.handleOnClick(e, 0)}
              >
                <Translate value="label_myEVs" />
              </p>
              <p
                className={this.state.tabIndex === 1 ? "selected" : ""}
                onClick={(e) => this.handleOnClick(e, 1)}
              >
                <Translate value="backOffice_network_contracts_title" />
              </p>
            </div>
          </Modal.Header>
          <Modal.Body>
            <form id="chargeAs-form" onSubmit={(e) => this.onSave(e)}>
              {this.state.tabIndex === 0 ? (
                <div>
                  {this.state.evsList?.map((ev) => (
                    <React.Fragment key={ev._id}>
                      {this.renderItemsEv(ev)}
                    </React.Fragment>
                  ))}
                </div>
              ) : (
                <div>
                  {this.state.contractsList.map((contract) => (
                    <React.Fragment key={contract._id}>
                      {this.renderItemsCard(contract)}
                    </React.Fragment>
                  ))}
                </div>
              )}
            </form>
          </Modal.Body>
          <Modal.Footer>
            <button type="submit" form="chargeAs-form">
              <Translate value="availabilityAccess_save" />
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default connect(null, { setAlert })(ChargeAs);
